<template>
  <footer class="home-footer">
    <section class="footer-inner">
      <div>
        <img
          class="img-logo"
          src="@/assets/img/images/logo-white.png"
          alt="logo"
        />
        <div class="">
          <img
            class="img-item"
            src="@/assets/img/images/footer/1.png"
            alt="footer1"
			@click="goWebsite('https://x.com/rwa_ltd?s=21&t=WsNz_1-HI8IWwAiYKqi0qg', '_blank')"
          />
          <img
            class="img-item"
            src="@/assets/img/images/footer/2.png"
            alt="footer2"
			@click="goWebsite('https://medium.com/@astro_8276', '_blank')"
          />
          <img
            class="img-item"
            src="@/assets/img/images/footer/3.png"
            alt="footer3"
			@click="goWebsite('https://t.me/hkrwac', '_blank')"
          />
          <img
            class="img-item"
            src="@/assets/img/images/footer/4.png"
            alt="footer4"
			@click="goWebsite('mailto:s@rwa.ltd', '_blank')"
          />
        </div>
      </div>
      <div class="footer-title-box">
        <div class="footer-title">
          <div>{{ $t('home.footer.about') }}</div>
          <p @click="$router.push({ path: '/footerAbout' })">{{ $t('home.footer.about') }}</p>
          <el-popover placement="top" trigger="hover">
            <p>{{ $t('home.footer.emailAddress') }}：s@rwa.ltd</p>
            <p  slot="reference">{{ $t('home.footer.contact') }}</p>
          </el-popover>
          <p @click="goWebsite('https://maps.app.goo.gl/aACCTM7MGAvWzhd87', '_blank')">{{ $t('home.footer.companyaddress') }}</p>
          <p @click="$router.push({ path: '/question' })">{{ $t('home.footer.questions') }}</p>
        </div>
        <div class="footer-title">
          <div>{{ $t('home.footer.legal') }}</div>
          <p @click="$router.push({ path: '/footerAgreement' })">{{ $t('home.footer.terms') }}</p>
		  <p @click="$router.push({ path: '/footerBuyProtocol' })">{{ $t('home.footer.buyProtocol') }}</p>
          <p @click="$router.push({ path: '/footerPrivacy' })">{{ $t('home.footer.privacy') }}</p>
        </div>
        <div class="footer-title">
          <div>{{ $t('home.footer.ecosystem') }}</div>
          <!-- <p>Genius Coffee</p> -->
          <p @click="$router.push({ path: '/download' })">{{ $t('home.footer.rwaApp') }}</p>
        </div>
      </div>
    </section>
    <aside class="copy">Copyright © 2026 RWA.LTD. All Rights Reserved.</aside>
  </footer>
</template>

<script>
export default {
  name: "v-footer",
  data() {
    return {};
  },
  methods: {
    goWebsite(url, win) {
		if(win == '_blank') {
			window.open(url, win);
		} else {
			window.location.href = url;
		}
    },
  }
};
</script>

<style lang="less" scoped>
.home-footer {
  width: 100%;
  height: 491px;
  background: #3f3f3f;
  .footer-inner {
    display: flex;
    padding: 0 260px;
    justify-content: center;
    .img-logo {
      width: 156px;
      height: 42px;
      margin-top: 120px;
    }
    .img-item {
      width: 45px;
      height: 45px;
      margin-top: 60px;
      margin-right: 40px;
    }
  }
  .footer-title-box {
    flex: 1;
    display: flex;
    margin-top: 120px;
    justify-content: space-evenly;
    .footer-title {
      div {
        font-family: PingFang SC, PingFang SC;
        font-weight: 400;
        font-size: 20px;
        color: #ffffff;
        margin-bottom: 44px;
      }
      p {
        cursor: pointer;
        font-family: PingFang SC, PingFang SC;
        font-weight: 400;
        font-size: 16px;
        color: #999999;
        margin-bottom: 20px;
      }
    }
  }
  .copy {
    text-align: center;
    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
    font-size: 16px;
    color: #ffffff;
    margin-top: 60px;
  }
}
</style>
